import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  PluginConfigurationComponent,
  PluginManagementService,
  PluginTranslationService,
} from '@valtimo/plugin';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  combineLatest,
  map,
  take,
} from 'rxjs';
import { ZakenNotificatiesApiConfig } from '../../models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'valtimo-notificaties-api-configuration',
  templateUrl: './zaken-notificaties-api-configuration.component.html',
  styleUrls: ['./zaken-notificaties-api-configuration.component.scss'],
})
export class ZakenNotificatiesApiConfigurationComponent
  implements PluginConfigurationComponent, OnInit, OnDestroy {
  @Input() save$!: Observable<void>;
  @Input() disabled$!: Observable<boolean>;
  @Input() pluginId!: string;
  @Input() prefillConfiguration$!: Observable<ZakenNotificatiesApiConfig>;

  @Output() valid = new EventEmitter<boolean>();
  @Output() configuration: EventEmitter<ZakenNotificatiesApiConfig> =
    new EventEmitter<ZakenNotificatiesApiConfig>();

  readonly authenticationPluginSelectItems$!: Observable<
    Array<{ id: string; text: string }>
  >;

  private saveSubscription!: Subscription;
  private readonly formValue$ = new BehaviorSubject<ZakenNotificatiesApiConfig | null>(null);
  private readonly valid$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly pluginManagementService: PluginManagementService,
    private readonly translateService: TranslateService,
    private readonly pluginTranslationService: PluginTranslationService
  ) {
    this.authenticationPluginSelectItems$ = combineLatest([
      this.pluginManagementService.getPluginConfigurationsByCategory(
        'notificaties-api-authentication'
      ),
      this.translateService.stream('key'),
    ]).pipe(
      map(([configurations]) =>
        configurations.map(configuration => ({
          id: configuration.id,
          text: `${configuration.title} - ${this.pluginTranslationService.instant(
            'title',
            configuration.pluginDefinition.key
          )}`,
        }))
      )
    );
  }

  ngOnInit(): void {
    this.openSaveSubscription();
  }

  ngOnDestroy(): void {
    this.saveSubscription?.unsubscribe();
  }

  formValueChange(formValue: ZakenNotificatiesApiConfig): void {
    this.formValue$.next(formValue);
    this.handleValid(formValue);
  }

  private handleValid(formValue: ZakenNotificatiesApiConfig): void {
    const valid = !!(formValue.configurationTitle && formValue.url && formValue.callbackUrl);

    this.valid$.next(valid);
    this.valid.emit(valid);
  }

  private openSaveSubscription(): void {
    this.saveSubscription = this.save$?.subscribe(save => {
      combineLatest([this.formValue$, this.valid$])
        .pipe(take(1))
        .subscribe(([formValue, valid]) => {
          if (valid) {
            this.configuration.emit(formValue);
          }
        });
    });
  }
}
